export enum ToastTypes {
  info = 'message--info',
  success = 'message--success',
  warning = 'message--warning',
  error = 'message--error',
}
